import { render } from "./badrequest.vue?vue&type=template&id=e7328106&lang=html"
import script from "./badrequest.vue?vue&type=script&lang=js"
export * from "./badrequest.vue?vue&type=script&lang=js"

import "./badrequest.vue?vue&type=style&index=0&id=e7328106&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__